require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (e) {
  var t = {};

  function o(r) {
    if (t[r]) return t[r].exports;
    var n = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      o.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 0);
}([function (e, t, o) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  },
      n = i(o(1)),
      u = i(o(2));

  function i(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var a = new Map([["small", {
    width: 560,
    height: 315
  }], ["medium", {
    width: 640,
    height: 360
  }], ["large", {
    width: 853,
    height: 480
  }], ["largest", {
    width: 1280,
    height: 720
  }]]);

  function l(e) {
    var t = e.videoId,
        o = e.autoplay,
        u = e.suggestions,
        i = e.controls,
        l = e.showInfo,
        s = e.enhancedPrivacy,
        d = e.width,
        f = e.height,
        c = e.size,
        h = function (e, t) {
      var o = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (o[r] = e[r]);
      }

      return o;
    }(e, ["videoId", "autoplay", "suggestions", "controls", "showInfo", "enhancedPrivacy", "width", "height", "size"]),
        p = function (e, t, o, r, n, u) {
      var i = [];
      o ? i.push("https://www.youtube-nocookie.com/embed/") : i.push("https://www.youtube.com/embed/");
      i.push(e), i.push(t ? "?autoplay=1" : "?autoplay=0"), r || i.push("&rel=0");
      n || i.push("&controls=0");
      u || i.push("&showinfo=0");
      return i.join("");
    }(t, o, s, u, i, l),
        g = function (e, t, o) {
      return o && a.has(o.toLowerCase()) ? a.get(o.toLowerCase()) : {
        width: e,
        height: t
      };
    }(d, f, c);

    return n["default"].createElement("iframe", r({
      width: g.width,
      height: g.height,
      src: p,
      frameBorder: "0",
      allowFullScreen: !0,
      title: "Youtube Embed Video"
    }, h));
  }

  l.propTypes = {
    videoId: u["default"].string.isRequired,
    width: u["default"].number,
    height: u["default"].number,
    size: u["default"].string,
    autoplay: u["default"].bool,
    enhancedPrivacy: u["default"].bool,
    suggestions: u["default"].bool,
    controls: u["default"].bool,
    showInfo: u["default"].bool
  }, l.defaultProps = {
    width: 560,
    height: 315,
    size: "",
    autoplay: !1,
    enhancedPrivacy: !1,
    suggestions: !0,
    controls: !0,
    showInfo: !0
  }, t["default"] = l;
}, function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("prop-types");
}]);